import React from 'react';
import { StyleSheet } from 'react-native';
import { Button, HStack, Modal, theme } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

export const CreditCardFormFooter = (props: CreditCardFormFooterProps) => {
  const { mode, isSaving, isDeleting, canSubmit, onDelete, onSubmit } = props;

  const { t } = useLocalizationContext();
  const isEditing = mode === 'edit';

  return (
    <Modal.Footer style={styles.footer} withoutTopBorder>
      <HStack itemsPerRow={isEditing ? 2 : 1} gap={theme.spacing['4']}>
        {isEditing ? (
          <Button
            testID="credit-card-form.remove"
            size="large"
            palette="caution"
            isLoading={isDeleting}
            accessibilityRole="button"
            accessibilityLabel={t('credit-card-form.remove')}
            accessibilityHint={t('credit-card-form.remove')}
            onPress={onDelete}
          >
            {t('credit-card-form.remove')}
          </Button>
        ) : null}

        <Button
          testID="credit-card-form.submit"
          size="large"
          palette="primary"
          isLoading={isSaving}
          disabled={!canSubmit}
          accessibilityRole="button"
          accessibilityLabel={t('credit-card-form.save')}
          accessibilityHint={t('credit-card-form.save')}
          accessibilityState={{ disabled: !canSubmit }}
          onPress={onSubmit}
        >
          {t('credit-card-form.save')}
        </Button>
      </HStack>
    </Modal.Footer>
  );
};

// ─── Types ─────────────────────────────────────────────────────────────

type CreditCardFormFooterProps = Readonly<{
  mode: 'add' | 'edit' | 'replace';
  isSaving?: boolean;
  isDeleting?: boolean;
  canSubmit: boolean;
  onSubmit: () => void;
  onDelete?: () => void;
}>;

// ─── Styles ────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  footer: {
    flexDirection: 'row',
    padding: theme.spacing['6'],
    paddingTop: theme.spacing['6'],
  },
});
